<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#info-modal {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 99999;

        div.info-box {
            width: 100%;
            max-width: 630px;
            min-width: 320px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ddd;
            -webkit-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.08);
            box-shadow: 0 1px 3px rgba(50, 50, 50, 0.08);
            -webkit-border-radius: 4px;
            border-radius: 4px;
            font-size: 16px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            div.info-label {
                color: black;
                font-family: 'Raleway', sans-serif;
                font-weight: bold;
                text-transform: uppercase;
                text-align: center;
                margin-bottom: 20px;
            }

            p.info-description {
                color: #666666;
                text-align: center;
            }

            button.call-button {
                border: 2px solid $secondary-color;
                border-radius: 30px;
                font-family: 'Raleway', sans-serif;
                background-color: white;
                width: 360px;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                padding: 10px;
                margin-top: 20px;
                display: block;
                margin: auto;
                outline:none;
                cursor: pointer;
                color: $secondary-color;

                &:hover {
                    background-color: $secondary-color;
                    color: white;
                }
            }

            .centered {
                margin: auto;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#info-modal {
            div.info-box {
                width: 95%;

                button.call-button {
                    width: 300px;
                }
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="info-modal" v-show="show" v-on:click="show = false">
        <div class="info-box" v-on:click.stop="">
            <form @submit.prevent="submitContact">
                <div class="info-label">{{ $t('info.label') }}</div>

                <p class="info-description">
                    {{ $t('info.description') }}
                </p>

                <button type="submit" class="call-button">
                    {{ $t('info.submitButton') }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../event-bus.js';

    export default {
        data() {
            return {
                show: false
            }
        },

        mounted() {
            EventBus.$on('info-modal', function () {
                this.show = true;
            }.bind(this));
        },

        methods: {
            submitContact() {
                window.location ='tel:+420296333666';
                //this.show = false;
            },
        }
    }
</script>
